/*
 * @Description: 高级搜索
 * @Author: zengweijin
 * @Date: 2019-09-10 14:31:50
 * @LastEditors: zengweijin
 * @LastEditTime: 2019-11-26 11:56:38
 */
import React from 'react'
import { Form, Input, DatePicker, TimePicker, InputNumber, Button, Row, Col, Tooltip } from 'antd'
import HighSelect from './highSelect'
const { RangePicker } = DatePicker;
import AddFieldsModal from "./AddFieldsModal";

/**
 *      searchType:"input",// 类型，可选值：输入框：input，下拉框：select，日期：date，时间：time，日期时间：datetime，数字：number
        parentField:"xxxx",// 级联下拉框时的上一级字段，值需要跟NHTable配置的一样
        dmbz:"xxx",// 下拉框的数据来源，如果没有传代码库标志或者下拉框配置标志则默认使用列表数据，
        sign:"xxxx",// 下拉框的数据来源，如果没有传代码库标志或者下拉框配置标志则默认使用列表数据，
        defaultSearch:true,// 默认true，如果不需要默认显示为高级搜索时设置为false

        说明：
        级联下拉框暂时只支持都是列表数据的情况
        字段为date(YYYY-MM-dd)，datetime(YYYY-MM-dd HH:mm:ss)，time(HH:mm)三种类型时，列表查询的数据必须是字符串且满足特定格式
 */
class HighSearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectData:{},
            tableSelect:[],
            dataSource:{},// 列表下拉框数据
            cascaderField:{},
            visible:false,
            searchCols:this.props.columns,
        };
    }
    componentDidMount() {
        let { columns=[], tableData=[] } = this.props;
        let tableSelect = this.getTableSelect(columns);
        let cascaderField = this.getCascaderField(columns);
        this.setState({tableSelect,cascaderField},()=>this.generateSelectData(tableData))
    }
    UNSAFE_componentWillReceiveProps(nextprops) {
        if ('columns' in nextprops &&  this.props.columns != nextprops.columns && nextprops.columns) {
            this.props.getHightSearchData && this.props.getHightSearchData(()=>{
                let { columns=[], tableData=[] } = nextprops;
                let tableSelect = this.getTableSelect(columns);
                let cascaderField = this.getCascaderField(columns);
                this.setState({tableSelect,cascaderField,searchCols:[...columns]},()=>this.generateSelectData(tableData))
            })
        } else if ('tableData' in nextprops && nextprops.tableData && this.props.tableData != nextprops.tableData) {
            this.generateSelectData(nextprops.tableData)
        }
    }
    // 获得级联字段的上下级关系
    getCascaderField = (columns) =>{
        let cascaderField = {};
        columns && columns.forEach(item=>{
            // 列表下拉框且存在parentField
            if (item.searchType && item.searchType === 'select' && !item.dmbz && !item.sign && item.parentField) {
                cascaderField[item.parentField] = item.dataIndex;
            }
        })
        return cascaderField;
    }
    onTableSelectChange = (field,value) => {
        let cascaderField = this.state.cascaderField;
        if (cascaderField[field]) {
            this.filterTableSelectData(field,value,cascaderField[field]);
        }
    }
    /**
     * 级联下拉框过滤下一级数据
     * @param curField 当前选择下拉框的字段标识
     * @param curvalue 当前下拉框选中的值
     * @param nextField 下一级下拉框的字段标识
     */
    filterTableSelectData = (curField,curvalue,nextField) => {
        let tableData = this.props.tableData;
        let dataSource = {...this.state.dataSource};
        let data = []
        if (tableData) {
            let setlist = new Set();
            if (curvalue && curvalue.length === 0) {
                tableData.forEach(item=>{
                   setlist.add(item[nextField]);
                });
            } else {
                tableData.forEach(item=>{
                    for (let v of curvalue) {
                        if (item[curField] === v) {
                            setlist.add(item[nextField]);
                        }
                    }
                });
            }
            data = [...setlist].map(item=>{
                return {label:item,value:item}
            })
        }
        dataSource[nextField] = data;
        this.setState({dataSource});
    }
    // 获取所有从下拉框获取数据的字段标识
    getTableSelect = (columns) => {
        let tableSelect = []
        columns && columns.forEach(item=>{
            if (item.searchType && item.searchType === 'select' && !item.dmbz && !item.sign) {
                tableSelect.push(item.dataIndex);
            }
        })
        return tableSelect;  
    }
    // 对所有从列表获取数据的下拉框统一获取数据
    generateSelectData = (tableData) => {
        let dataSource = {};
        let {tableSelect=[]} = this.state;
        // 遍历列表数据
        tableData && tableData.forEach((item,index)=>{
            for(let dataIndex of tableSelect) {
                if (!dataSource[dataIndex]) {
                    dataSource[dataIndex] = new Set();
                }
                if (item[dataIndex] && item[dataIndex].trim()!=='') {
                    dataSource[dataIndex].add(item[dataIndex]);
                }
            }
        })
        for (let dataIndex of tableSelect) {
            if (dataSource[dataIndex]) {
                dataSource[dataIndex] = [...dataSource[dataIndex]].map(item=>{
                   return {label:item,value:item}
               });
            }
        }
        this.setState({dataSource})
    }
    // 高级搜索
    hightSearch = (fieldpro, index) => {
        // 如果不需要作为高级搜索字段或者没有设置高级搜索字段的类型
        if (fieldpro.defaultSearch ==='false' || fieldpro.defaultSearch === false  || !fieldpro.searchType ) {
            return null;
        }
        const { getFieldDecorator } = this.props.form;
        if (fieldpro.searchType === 'input') {
            // 输入框
            return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index}>
                {getFieldDecorator(`S_${fieldpro.dataIndex}_LK`, {
                })(
                    <Input placeholder={`请输入${fieldpro.title}`} />
                )}</Form.Item>;
        } else if (fieldpro.searchType === 'select') {
            // 下拉框
            if (fieldpro.dmbz) {
                // 存在代码标志，根据代码标志获取数据
                return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index}>
                    {getFieldDecorator(`S_${fieldpro.dataIndex}_IN`, {
                    })(
                        <HighSelect mode='multiple' maxTagCount={3} sign={`DMK_${fieldpro.dmbz}`} placeholder={`请选择${fieldpro.title}`} />
                    )}</Form.Item>;
            } else if (fieldpro.sign) {
                // 不存在代码标志，存在下拉框标志，根据标志获取数据
                return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index}>
                    {getFieldDecorator(`S_${fieldpro.dataIndex}_IN`, {
                    })(
                        <HighSelect mode='multiple' maxTagCount={3}  sign={fieldpro.sign} placeholder={`请选择${fieldpro.title}`} />
                    )}</Form.Item>;
            } else {
                // 代码标志和sign都不存在，默认是列表数据
                return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index}>
                    {getFieldDecorator(`S_${fieldpro.dataIndex}_IN`, {
                    })(
                        <HighSelect mode='multiple' maxTagCount={3} onChange={(value,label)=>this.onTableSelectChange(fieldpro.dataIndex,value)} dataSource={this.state.dataSource[fieldpro.dataIndex] || []} onCancel={()=>this.setState({hightSearch:false})} placeholder={`请选择${fieldpro.title}`} />
                    )}</Form.Item>;
            }
        } else if (fieldpro.searchType === 'date') {
            // 日期
            return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index}>
                {getFieldDecorator(`D_${fieldpro.dataIndex}_date`, {
                })(
                    <RangePicker />
                )}</Form.Item>
        } else if (fieldpro.searchType === 'time') {
            // 时间,没有时间范围组件
            return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index}>
                <Form.Item style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
                {getFieldDecorator(`T_${fieldpro.dataIndex}_time_start`, {
                })(
                    <TimePicker format='HH:mm' />
                )}</Form.Item>
                <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>~</span>
                <Form.Item  style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
                {getFieldDecorator(`T_${fieldpro.dataIndex}_time_end`, {
                })(
                    <TimePicker format='HH:mm' />
                )}</Form.Item>
                </Form.Item>
        } else if (fieldpro.searchType === 'datetime') {
            // 日期时间
            return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index} >
                {getFieldDecorator(`DT_${fieldpro.dataIndex}_date`, {
                })(
                    <RangePicker style={{width:'auto'}} showTime format='YYYY-MM-DD HH:mm:ss' />
                )}</Form.Item>
        } else if (fieldpro.searchType === 'number') {
            // 数字
            return <Form.Item label={<Tooltip title={fieldpro.title}>{fieldpro.title}</Tooltip>} key={index}>
                <Form.Item style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
                    {getFieldDecorator(`N_${fieldpro.dataIndex}_number_start`, {
                    })(
                        <InputNumber style={{ width: '100%' }} placeholder={`请输入${fieldpro.title}`} />
                    )}
                </Form.Item>
                <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>~</span>
                <Form.Item style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
                    {getFieldDecorator(`N_${fieldpro.dataIndex}_number_end`, {
                    })(
                        <InputNumber style={{ width: '100%' }} placeholder={`请输入${fieldpro.title}`} />
                    )}
                </Form.Item>
                </Form.Item>;
        }
    }
    showAddModal = () => {
		this.setState({ visible: true });
    };
    // 添加搜索字段模态框-关闭
	hideAddModal = () => {
		this.setState({ visible: false });
	};
    render() {
        const { columns } = this.props;
        const { visible, searchCols=[] } = this.state;
        let checkedCol = searchCols.filter(item=>(item.defaultSearch!=="false"&&item.defaultSearch !== false)&&item.searchType)
        checkedCol = checkedCol.map(item=>item.dataIndex)
        let ncolumns = columns.filter(item=>item.title !=='序号'&&item.searchType)
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
              },
              wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
              },
        }
        return (
            <div>
                <Form {...formItemLayout}>
                    <Row gutter={16} type="flex" align="middle">
                    {searchCols && searchCols.map((item, index) => {
                        let comp = this.hightSearch(item, index);
                        if (comp != null) {
                            return <Col key={index} xxl={6} xl={8} lg={12} md={12} sm={24}>{comp}</Col>;
                        }
                        return null;
                    })}
                        <Col span={24} style={{ textAlign: "right" }}>
                            <Button type="primary" onClick={this.props.onSearch}>
                                执行高级搜索
                            </Button>
                            <Button onClick={this.showAddModal}>添加搜索字段</Button>
                            <Button onClick={this.props.onRest}>
                                重置
                            </Button>
                            <a style={{marginLeft:10}} onClick={this.props.onCancel}>[关闭高级搜索]</a>
                        </Col>
                    </Row>
                </Form>
                <AddFieldsModal
					visible={visible}
					data={ncolumns}
					checkedList={checkedCol}
					onOk={result=>this.setState({searchCols:result,visible:false},this.props.refreshHeight)}
					onCancel={this.hideAddModal}
				/>
            </div>
        )
    }
}
const WrapHighSearchForm = Form.create()(HighSearchForm)
export default WrapHighSearchForm;



// WEBPACK FOOTER //
// ./components/tjcx/hjblcx/highSearchForm.js